export interface Curso {
  id: string;
  titulo: string;
  descricao: string;
  categoria: string;
  nivel: string;
  aulas: number;
  imagem: string;
  material: string;
  preco: number;
}

export const cursos: Curso[] = [
  // === LEITURA E TEORIA MUSICAL ===
  // Leitura e Teoria Musical: R$9,90 a R$29,90
  {
    id: "iniciacao-musical",
    titulo: "Iniciação Musical",
    descricao: "Curso completo para quem está começando no mundo da música. Aprenda os fundamentos da teoria musical, notas, compassos, claves e ritmo de forma prática e didática.",
    categoria: "Leitura e Teoria Musical",
    nivel: "Iniciante",
    aulas: 20,
    imagem: "https://readdy.ai/api/search-image?query=Music%20education%20black%20and%20golden%20notes%20sheet%20music%20abstract%20artistic%20dark%20background&width=400&height=250&seq=godoy-curso-iniciacao&orientation=landscape",
    material: "Apostila em PDF + Exercícios",
    preco: 9.90,
  },
  {
    id: "leitura-partituras",
    titulo: "Leitura de Partituras",
    descricao: "Domine a arte de ler partituras como um profissional. Do básico ao avançado: claves, notas na pauta, compassos, dinâmicas, articulações e muito mais.",
    categoria: "Leitura e Teoria Musical",
    nivel: "Iniciante ao Intermediário",
    aulas: 24,
    imagem: "https://readdy.ai/api/search-image?query=Sheet%20music%20reading%20education%20golden%20black%20piano%20keys%20abstract%20dark%20artistic&width=400&height=250&seq=godoy-curso-leitura&orientation=landscape",
    material: "Apostila em PDF + Partituras de Exemplo",
    preco: 14.90,
  },
  {
    id: "pozzoli-1",
    titulo: "Pozzoli — Estudo Progressivo",
    descricao: "Método completo do Pozzoli para leitura musical progressiva. Um dos métodos mais tradicionais e eficientes para desenvolver a leitura rítmica e melódica.",
    categoria: "Leitura e Teoria Musical",
    nivel: "Iniciante",
    aulas: 30,
    imagem: "https://readdy.ai/api/search-image?query=Progressive%20music%20study%20method%20violin%20notes%20abstract%20golden%20dark%20artistic%20education&width=400&height=250&seq=godoy-curso-pozzoli&orientation=landscape",
    material: "Método Pozzoli em PDF + Áudio de Referência",
    preco: 19.90,
  },
  {
    id: "bona-1",
    titulo: "Bona — Método de Solfejo",
    descricao: "Método completo de solfejo e canto coral do Maestro Bona. Ideal para quem quer desenvolver a percepção musical e a vocalização correta das notas.",
    categoria: "Leitura e Teoria Musical",
    nivel: "Iniciante",
    aulas: 28,
    imagem: "https://readdy.ai/api/search-image?query=Choir%20singing%20solfege%20music%20education%20golden%20black%20notes%20abstract%20artistic%20dark&width=400&height=250&seq=godoy-curso-bona&orientation=landscape",
    material: "Método Bona em PDF + Áudio de Referência",
    preco: 29.90,
  },

  // === HARMONIA MUSICAL ===
  // Preços: R$49,90 a R$89,90
  {
    id: "harmonia-basica",
    titulo: "Harmonia Básica para Teclado",
    descricao: "Aprenda os fundamentos da harmonia aplicada ao teclado e piano. Acordes, progressões, cifras e acompanhamento para música gospel.",
    categoria: "Harmonia Musical",
    nivel: "Iniciante",
    aulas: 18,
    imagem: "https://readdy.ai/api/search-image?query=Piano%20keyboard%20harmony%20chords%20music%20education%20golden%20black%20abstract%20dark%20artistic&width=400&height=250&seq=godoy-curso-harmonia&orientation=landscape",
    material: "Apostila em PDF + Tabelas de Acordes",
    preco: 49.90,
  },
  {
    id: "harmonia-intermediaria",
    titulo: "Harmonia Intermediária para Teclado",
    descricao: "Aprofunde seus conhecimentos em harmonia com progressões avançadas, acordes estendidos, substituições e acompanhamento mais sofisticado.",
    categoria: "Harmonia Musical",
    nivel: "Intermediário",
    aulas: 20,
    imagem: "https://readdy.ai/api/search-image?query=Piano%20keyboard%20advanced%20harmony%20chords%20progression%20music%20education%20golden%20dark%20background%20abstract%20artistic&width=400&height=250&seq=godoy-curso-harmonia-int&orientation=landscape",
    material: "Apostila em PDF + Exercícios Práticos",
    preco: 59.90,
  },
  {
    id: "harmonia-avancada",
    titulo: "Harmonia Avançada e Reharmonização",
    descricao: "Domine a reharmonização, acordes de passagem, trítono substituto, acordes diminutos e aumentados aplicados à música gospel e adoração.",
    categoria: "Harmonia Musical",
    nivel: "Avançado",
    aulas: 22,
    imagem: "https://readdy.ai/api/search-image?query=Advanced%20piano%20harmony%20reharmonization%20complex%20chords%20music%20sheet%20golden%20dark%20artistic%20education&width=400&height=250&seq=godoy-curso-harmonia-av&orientation=landscape",
    material: "Apostila em PDF + Estudos de Caso",
    preco: 69.90,
  },
  {
    id: "modulacao-passes",
    titulo: "Modulação e Passes Gospel",
    descricao: "Aprenda as técnicas de modulação entre tons, passes cromáticos e transições suaves entre músicas no estilo gospel brasileiro.",
    categoria: "Harmonia Musical",
    nivel: "Intermediário ao Avançado",
    aulas: 16,
    imagem: "https://readdy.ai/api/search-image?query=Music%20modulation%20modulation%20key%20changes%20piano%20golden%20black%20abstract%20dark%20artistic%20education&width=400&height=250&seq=godoy-curso-modulacao&orientation=landscape",
    material: "Apostila em PDF + Tabela de Modulações",
    preco: 79.90,
  },
  {
    id: "teoria-gospel",
    titulo: "Teoria Musical Aplicada ao Gospel",
    descricao: "Como aplicar a teoria musical na prática do gospel. Modulações, passes, reharmonização e técnicas específicas do estilo gospel brasileiro.",
    categoria: "Harmonia Musical",
    nivel: "Intermediário ao Avançado",
    aulas: 22,
    imagem: "https://readdy.ai/api/search-image?query=Gospel%20music%20theory%20worship%20piano%20keyboard%20golden%20black%20abstract%20dark%20artistic&width=400&height=250&seq=godoy-curso-teoria&orientation=landscape",
    material: "Apostila em PDF + Exemplos em Partitura",
    preco: 89.90,
  },

  // === PRODUÇÃO MUSICAL ===
  // Preços: R$89,90 a R$149,90
  {
    id: "sibelius-intro",
    titulo: "Sibelius — Módulo Introdutório",
    descricao: "Conheça a interface do Sibelius, configuração inicial, criação de partituras do zero e ferramentas essenciais para transcrição musical.",
    categoria: "Produção Musical",
    nivel: "Iniciante",
    aulas: 14,
    imagem: "https://readdy.ai/api/search-image?query=Sibelius%20notation%20software%20interface%20music%20production%20dark%20background%20golden%20abstract%20artistic&width=400&height=250&seq=godoy-curso-sib-intro&orientation=landscape",
    material: "Apostila em PDF + Arquivos de Exemplo",
    preco: 89.90,
  },
  {
    id: "sibelius-gravacao",
    titulo: "Sibelius — Gravação e Input",
    descricao: "Técnicas de entrada de notas via teclado MIDI, gravação em tempo real, edição de performance e quantização no Sibelius.",
    categoria: "Produção Musical",
    nivel: "Intermediário",
    aulas: 16,
    imagem: "https://readdy.ai/api/search-image?query=MIDI%20keyboard%20music%20notation%20input%20recording%20studio%20dark%20background%20golden%20abstract%20artistic&width=400&height=250&seq=godoy-curso-sib-grav&orientation=landscape",
    material: "Apostila em PDF + Arquivos MIDI",
    preco: 99.90,
  },
  {
    id: "sibelius-edicao",
    titulo: "Sibelius — Edição e Formatação",
    descricao: "Edição avançada de partituras: layout, espaçamento, formatação profissional, plugins, partes separadas e preparação para impressão.",
    categoria: "Produção Musical",
    nivel: "Intermediário",
    aulas: 18,
    imagem: "https://readdy.ai/api/search-image?query=Music%20sheet%20editing%20engraving%20professional%20notation%20dark%20background%20golden%20abstract%20artistic&width=400&height=250&seq=godoy-curso-sib-edicao&orientation=landscape",
    material: "Apostila em PDF + Templates Profissionais",
    preco: 109.90,
  },
  {
    id: "sibelius-transcricao",
    titulo: "Sibelius — Transcrição Profissional",
    descricao: "Fluxo completo de transcrição: de áudio a partitura. Técnicas de escuta, identificação de acordes, transposição e revisão final.",
    categoria: "Produção Musical",
    nivel: "Avançado",
    aulas: 20,
    imagem: "https://readdy.ai/api/search-image?query=Professional%20music%20transcription%20audio%20to%20sheet%20notation%20workflow%20dark%20background%20golden%20abstract%20artistic&width=400&height=250&seq=godoy-curso-sib-trans&orientation=landscape",
    material: "Apostila em PDF + Áudio de Exercícios",
    preco: 119.90,
  },
  {
    id: "protools-intro",
    titulo: "ProTools — Módulo Introdutório",
    descricao: "Interface do ProTools, sessões, tracks, regiões, ferramentas básicas de edição e configuração de hardware de áudio.",
    categoria: "Produção Musical",
    nivel: "Iniciante",
    aulas: 16,
    imagem: "https://readdy.ai/api/search-image?query=ProTools%20DAW%20audio%20production%20software%20interface%20studio%20dark%20background%20golden%20abstract%20artistic&width=400&height=250&seq=godoy-curso-pt-intro&orientation=landscape",
    material: "Apostila em PDF + Session de Exemplo",
    preco: 109.90,
  },
  {
    id: "protools-gravacao",
    titulo: "ProTools — Gravação de Áudio",
    descricao: "Técnicas de gravação de voz e instrumentos, microfonação, takes, comping e organização de sessões no ProTools.",
    categoria: "Produção Musical",
    nivel: "Intermediário",
    aulas: 18,
    imagem: "https://readdy.ai/api/search-image?query=Studio%20recording%20microphone%20vocal%20booth%20professional%20audio%20production%20dark%20background%20golden%20abstract%20artistic&width=400&height=250&seq=godoy-curso-pt-grav&orientation=landscape",
    material: "Apostila em PDF + Sessions de Exercício",
    preco: 119.90,
  },
  {
    id: "protools-edicao",
    titulo: "ProTools — Edição e Mixagem",
    descricao: "Edição de áudio: comping, elastic audio, fades, clip gain. Mixagem básica: EQ, compressão, pan, reverb e delay.",
    categoria: "Produção Musical",
    nivel: "Intermediário",
    aulas: 20,
    imagem: "https://readdy.ai/api/search-image?query=Audio%20mixing%20console%20EQ%20compressor%20studio%20dark%20background%20golden%20abstract%20artistic&width=400&height=250&seq=godoy-curso-pt-edicao&orientation=landscape",
    material: "Apostila em PDF + Sessions Multitrack",
    preco: 129.90,
  },
  {
    id: "melodyne-intro",
    titulo: "Melodyne — Módulo Introdutório",
    descricao: "Conheça o Melodyne: transferência de áudio, blobs, ferramentas de correção de pitch e tempo. Interface e workflow básico.",
    categoria: "Produção Musical",
    nivel: "Iniciante",
    aulas: 12,
    imagem: "https://readdy.ai/api/search-image?query=Melodyne%20pitch%20correction%20software%20interface%20waveforms%20dark%20background%20golden%20abstract%20artistic&width=400&height=250&seq=godoy-curso-mel-intro&orientation=landscape",
    material: "Apostila em PDF + Arquivos de Exemplo",
    preco: 99.90,
  },
  {
    id: "melodyne-edicao",
    titulo: "Melodyne — Edição Vocal Avançada",
    descricao: "Correção avançada de vocal: pitch, vibrato, sibilância, formantes, macros e workflow profissional de edição vocal no Melodyne.",
    categoria: "Produção Musical",
    nivel: "Intermediário ao Avançado",
    aulas: 16,
    imagem: "https://readdy.ai/api/search-image?query=Vocal%20pitch%20correction%20editing%20waveform%20display%20professional%20dark%20background%20golden%20abstract%20artistic&width=400&height=250&seq=godoy-curso-mel-edicao&orientation=landscape",
    material: "Apostila em PDF + Vocais de Exercício",
    preco: 129.90,
  },
  {
    id: "logicpro-intro",
    titulo: "Logic Pro — Módulo Introdutório",
    descricao: "Interface do Logic Pro, configuração de projetos, tracks, regiões, Smart Controls e biblioteca de sons do Logic.",
    categoria: "Produção Musical",
    nivel: "Iniciante",
    aulas: 14,
    imagem: "https://readdy.ai/api/search-image?query=Logic%20Pro%20Apple%20DAW%20music%20production%20software%20interface%20dark%20background%20golden%20abstract%20artistic&width=400&height=250&seq=godoy-curso-logic-intro&orientation=landscape",
    material: "Apostila em PDF + Projeto de Exemplo",
    preco: 109.90,
  },
  {
    id: "logicpro-gravacao",
    titulo: "Logic Pro — Gravação e Produção",
    descricao: "Gravação MIDI e áudio no Logic Pro, Flex Time, Flex Pitch, Drummer, loops e produção musical completa dentro do DAW.",
    categoria: "Produção Musical",
    nivel: "Intermediário",
    aulas: 18,
    imagem: "https://readdy.ai/api/search-image?query=Apple%20Logic%20Pro%20music%20production%20recording%20MIDI%20keyboard%20dark%20background%20golden%20abstract%20artistic&width=400&height=250&seq=godoy-curso-logic-grav&orientation=landscape",
    material: "Apostila em PDF + Projetos de Exercício",
    preco: 129.90,
  },
  {
    id: "logicpro-edicao",
    titulo: "Logic Pro — Edição e Mixagem",
    descricao: "Edição avançada, plugins nativos do Logic, mixagem com Channel EQ, Compressor, Space Designer, Limiter e exportação profissional.",
    categoria: "Produção Musical",
    nivel: "Intermediário ao Avançado",
    aulas: 20,
    imagem: "https://readdy.ai/api/search-image?query=Music%20mixing%20mastering%20plugins%20EQ%20compressor%20dark%20background%20studio%20golden%20abstract%20artistic&width=400&height=250&seq=godoy-curso-logic-edicao&orientation=landscape",
    material: "Apostila em PDF + Projetos Multitrack",
    preco: 149.90,
  },
];